import { render, staticRenderFns } from "./RentalsPageTab.vue?vue&type=template&id=6dc9748c&scoped=true"
import script from "./RentalsPageTab.vue?vue&type=script&lang=js"
export * from "./RentalsPageTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc9748c",
  null
  
)

export default component.exports